export const TELEOP_ALERT_CONTAINER_ID = "teleop-alert-container";

/** @deprecated Use TELEOP_ALERT_CONTAINER_ID instead */
export const TELEOP_ANT_ALERT_CONTAINER_ID = TELEOP_ALERT_CONTAINER_ID;
